export const transformResponseReturnInstruction = response => ({
  name: response.name,
  type: response.type,
  steps: response.steps,
  delivery_method_ids: response.delivery_method_ids,
})

export const transformRequestSaveReturnInstruction = ({ storeId, returnInstructionSetId, payload }) => ({
  storeId,
  returnInstructionSetId,
  payload: {
    name: payload.name,
    type: payload.type,
    steps: payload.steps,
  },
})
